module.exports = __webpack_public_path__ + "media/images/lb/643-3f0fb3e22a950eaa56d75812eee88014.svg";